import qs from 'query-string';
import SuperFetchV2 from '../../superFetchV2';
import {
  MultiChannelOrderItemBulkInsertRequestDto,
  MultiChannelOrderItemBulkInsertResponseDto,
  MultiChannelOrderItemDeliveryTrackingFindResponseDto,
  MultiChannelOrderItemExcelDownloadRequestDto,
  MultiChannelOrderItemExcelDownloadResponseDto,
  MultiChannelOrderItemsFindResponseDto,
  MultiChannelOrderItemsUpdateStatusRequestBodyDto,
  MultiChannelOrderItemsUpdateStatusResponseDto,
} from '../../../types/api/multi-channels';
import { OrderExcelUploadItem } from '../../../types/multiChannel';
import { MultiChannelOrderListRequest } from '../../../types/multiChannel/orderManagement';

class MultiChannelApi {
  /**
   * 주문 생성 업로드
   */
  // todo: 스웨거에 정의된 타입이 명확하지 않아 임시로 클라이언트에서 생성한 타입 사용합니다 문서 변경 후 타입 변경 필요 (스웨거에 object로 표시되어 제대로 된 타입 추론이 불가능)
  orderItemsExcelUpload = (data: FormData): Promise<{ multiChannelOrderItems: Omit<OrderExcelUploadItem, 'id'>[] }> =>
    SuperFetchV2.post(`/multi-channels/order-items/excel-upload`, data);

  /**
   * 주문 데이터 저장
   */
  createOrderItems = (
    data: MultiChannelOrderItemBulkInsertRequestDto,
  ): Promise<MultiChannelOrderItemBulkInsertResponseDto> => SuperFetchV2.post(`/multi-channels/order-items/bulk`, data);

  /**
   * 멀티채널 주문 내역 조회
   */
  getOrderList = (data: MultiChannelOrderListRequest): Promise<MultiChannelOrderItemsFindResponseDto> =>
    SuperFetchV2.get(`/multi-channels/order-items?${qs.stringify(data, { skipNull: true, skipEmptyString: true })}`);

  /**
   * 멀티채널 주문 상태 업데이트
   */
  updateMultiChannelOrderStatus = (
    data: MultiChannelOrderItemsUpdateStatusRequestBodyDto,
  ): Promise<MultiChannelOrderItemsUpdateStatusResponseDto> =>
    SuperFetchV2.patch(`/multi-channels/order-items/status`, data);

  /**
   * 주문 배송 추적 조회
   */
  getMultiChannelDeliveryTracking = (data: number): Promise<MultiChannelOrderItemDeliveryTrackingFindResponseDto> =>
    SuperFetchV2.get(`/multi-channels/order-items/deliveries/${data}/tracking`);

  /**
   * 엑셀 파일 다운로드
   */
  downloadExcelFile = (
    data: MultiChannelOrderItemExcelDownloadRequestDto,
  ): Promise<MultiChannelOrderItemExcelDownloadResponseDto> =>
    SuperFetchV2.post(`/multi-channels/order-items/excel-download`, data);
}
export default new MultiChannelApi();
